import * as React from 'react';
import { UIHeading1 } from '@cian/ui-kit';
import { getHeading } from '../../selectors/seo/getHeading';
import { useSelector } from 'react-redux';
import { HeadingWrapper } from '../../components/HeadingWrapper';
import { BreadcrumbsContainer } from '../Breadcrumbs';
import { QuickLinks } from '../QuickLinksContainer';
import { Subheading } from '../Subheading';
import { getMapFullUrl, selectTotal } from '../../selectors/offersData';
import { MapButton } from '../../components/MapButton';

export const Heading = () => {
  const heading = useSelector(getHeading);
  const mapFullUrl = useSelector(getMapFullUrl);
  const hasOffers = Boolean(useSelector(selectTotal));

  return (
    <HeadingWrapper
      breadcrumbs={<BreadcrumbsContainer />}
      heading={
        <UIHeading1 data-testid="Heading" as="h1">
          {heading}
        </UIHeading1>
      }
      subtitle={<Subheading />}
      quickLinks={<QuickLinks />}
      mapLink={hasOffers && mapFullUrl && <MapButton mapFullUrl={mapFullUrl} />}
    />
  );
};
